import { useMutation } from '@tanstack/react-query';
import { useToast } from 'corso-admin-ui';
import api from '~/api';

export function usePublishStoreAlert() {
  const toast = useToast();
  return useMutation({
    mutationFn: api.storeAlerts.publish,
    onSuccess: ({ storeCount }) =>
      toast.show(`Published alert to ${storeCount} stores`),
    onError: () => toast.show('Failed to publish alert'),
  });
}
